import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const STEP_PARAMETER = "lock_calc_tab";
const LAST_STEP = 3;

/** Keeps URL parsing and navigation outside the calculator composition root. */
export const useLockCalculatorWizard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentStep = useMemo(() => {
    const raw = searchParams.get(STEP_PARAMETER);
    const value = Number(raw);
    return !raw || Number.isNaN(value) || value < 0 ? 0 : Math.min(value, LAST_STEP);
  }, [searchParams]);

  // extraParams go in the same navigation: a second setSearchParams right after
  // would start from the same stale params and drop this one.
  const goToStep = useCallback(
    (index: number, extraParams?: Record<string, string>) => {
      setSearchParams((params) => {
        const next = new URLSearchParams(params);
        next.set(STEP_PARAMETER, String(index));
        Object.entries(extraParams ?? {}).forEach(([key, value]) => next.set(key, value));
        return next;
      });
    },
    [setSearchParams],
  );

  return { currentStep, goToStep };
};
